import { render, staticRenderFns } from "./CustomLogout.vue?vue&type=template&id=8e3e2dc2&scoped=true&"
import script from "./CustomLogout.vue?vue&type=script&lang=js&"
export * from "./CustomLogout.vue?vue&type=script&lang=js&"
import style0 from "./CustomLogout.vue?vue&type=style&index=0&id=8e3e2dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3e2dc2",
  null
  
)

export default component.exports